export const config = {
  title: "West Lake Landscaping & Maintenance LLC | Premier Landscaping Services in Florida",
  meta: {
    description:
      "West Lake Landscaping & Maintenance LLC offers top-tier landscaping and maintenance services in Florida, specializing in lawn care, garden design, and seasonal clean-ups.",
    keywords: [
      'Landscaping Florida',
      'Lawn Care',
      'Garden Design',
      'Seasonal Clean-Ups',
      'West Lake Landscaping',
      'Maintenance Services',
      'Florida Landscaping',
      'Landscape Maintenance',
      'Residential Landscaping',
      'Commercial Landscaping',
      'MyBizSolutions LLC',
      'BizSolutions LLC'
    ],
    author: "West Lake Landscaping & Maintenance LLC",
    canonicalUrl: 'https://westlakelandscapingmaintenancellc.com/',
  },
  sections: {
    header: {
      businessName: "West Lake Landscaping & Maintenance LLC",
    },
    sectionB: {
      heroTitle: "West Lake Landscaping & Maintenance LLC",
      heroSubtitle: 'Transforming Your Outdoor Spaces in Florida',
      learnAboutText: 'Explore Our Services',
      phoneNumber: '7272269274', 
      phoneLabel: '(727) 226-9274',
      heroBackgroundImage:
        "https://media.istockphoto.com/id/170635446/photo/lawn-mower.jpg?s=612x612&w=0&k=20&c=USw2qaz68osQbejlrltL8fJmzPIvH1vbHd1zDyO_68s=", 
      cardData: [
        {
          title: 'Mission',
          description:
            'At West Lake Landscaping & Maintenance LLC, we are dedicated to providing superior landscaping and maintenance services in Clearwater and beyond. Our unwavering commitment to excellence, unmatched expertise, and customer-centric approach sets us apart as the premier choice for all your landscaping needs.',
        },
        {
          title: 'Vision',
          description:
            'Our vision at West Lake Landscaping & Maintenance LLC is to be the leading provider of landscaping and maintenance services in Clearwater, FL. We strive to deliver exceptional results through our unparalleled expertise, dedication to customer satisfaction, and commitment to exceeding expectations.',
        },
        {
          title: 'Why Choose Us',
          description:
            'At West Lake Landscaping & Maintenance LLC, we are dedicated to providing top-quality landscaping and maintenance services to our clients in the Clearwater area. Our team of experts brings a wealth of knowledge and experience to every project, ensuring exceptional results and unmatched expertise.',
        },
      ],
      description:
        "At West Lake Landscaping & Maintenance LLC, we are dedicated to enhancing the beauty and functionality of your outdoor spaces. Our team of experts provides a range of services, including lawn care, garden design, and seasonal clean-ups, ensuring your property remains in top condition year-round.",
    },
    sectionC: {
      servicesTitle: 'Our Services',
      servicesDescription:
        "Discover the comprehensive landscaping and maintenance services we offer to meet your outdoor needs.",
      cards: [
        {
          title: 'Trim Palm Tree',
          description:
            "Trim your palm trees with ease and precision with our top-notch service provided by West Lake Landscaping & Maintenance LLC. Our company, located in Clearwater, FL, specializes in keeping your palm trees healthy and beautiful.",
          imageSrc:
            'https://firebasestorage.googleapis.com/v0/b/interscopemediacrm.appspot.com/o/Stock%2Flandscaping%2FPalm%20Removal-2-2406.webp?alt=media&token=55c5293d-44bc-4aa5-97fd-94aced98e3f6',
          imageAlt: 'Trim Palm Tree'
        },
        {
          title: 'Trim Bushes',
          description:
            "Get your bushes looking their best with West Lake Landscaping & Maintenance LLC. Our team of experts will skillfully trim and shape your bushes, creating a clean and polished appearance for your outdoor space.",
          imageSrc:
            'https://firebasestorage.googleapis.com/v0/b/interscopemediacrm.appspot.com/o/Stock%2Flandscaping%2FHedge%20Trimming-8614.webp?alt=media&token=744dc3e4-f04d-4f55-a322-ef04a84c9496', 
          imageAlt: 'Trim Bushes',
        },
        {
          title: 'Sod Installation',
          description:
            'Transform your outdoor space into a lush and vibrant oasis with Sod Installation from West Lake Landscaping & Maintenance LLC.',
          imageSrc:
            'https://firebasestorage.googleapis.com/v0/b/interscopemediacrm.appspot.com/o/Stock%2Flandscaping%2FSod%20installation%202-3652.webp?alt=media&token=cc82865f-3ca9-4b66-a840-6ad6370b957e',
          imageAlt: 'Sod Installation',
        },
      ],
      otherServicesTitle: 'Additional Services',
      otherServicesList: [
        'Lawn Mowing',
        'Mulching Services',
        'Yard Clean-Up',
        'Pressure Washing',
        'Paver Installation',
        'Rock Decoration',
        'Irrigation Services',
      ],
    },
    sectionD: {
      aboutTitle: 'About Us',
      aboutImage: {
        src:
          'https://firebasestorage.googleapis.com/v0/b/interscopemediacrm.appspot.com/o/Stock%2Flandscaping%2FBush%20Trimming-432.webp?alt=media&token=28ef39b6-84e8-4ace-bb6c-967cc3fab7da',
        alt: "West Lake Landscaping Team",
      },
      aboutText: [
        "West Lake Landscaping & Maintenance LLC is more than just your average landscaping company - we are dedicated to providing exceptional services and creating outdoor spaces that will truly make a difference in your life. Our team is passionate about nature and committed to delivering high quality work with integrity and professionalism.",
        "West Lake Landscaping & Maintenance LLC has been serving the Florida community with exceptional landscaping services. Our experienced team is committed to delivering quality workmanship and outstanding customer service, ensuring your outdoor spaces reflect your vision and thrive throughout the seasons.",
      ],
    },
    sectionE: {
      profileImage: 'https://firebasestorage.googleapis.com/v0/b/interscopemediacrm.appspot.com/o/Clientes%2FVfx5RIruaJEZtIPW6GtA%2FVfx5RIruaJEZtIPW6GtA_normalLogo.webp?alt=media&token=77d6499f-e231-469a-8d2f-cdeac8855e0d',
      profileAlt: "West Lake Landscaping & Maintenance LLC",
      businessName: "West Lake Landscaping & Maintenance LLC",
      contact: {
        phone: '7272269274', 
        phoneLabel: '(727) 226-9274',
        email: 'epimart1796@gmail.com',
        website: 'https://westlakelandscapingmaintenancellc.com/',
        address: 'Clearwater, FL, USA', 
      },
      socialMedia: {
        googlePlus: null,
        linkedIn: null,
        facebook: null,
        twitter: null,
        tiktok: 'https://www.tiktok.com/@west.lake.landsca',
        instagram: null,
        youtube: null,
      },
    },
    sectionF: {
      address: 'Clearwater, FL, USA', 
      googleMapsEmbedUrl:
        'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3468.694351494156!2d-82.80010268492263!3d27.96585377649564!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88c2f615d774b5b7%3A0x59e74108bb40832c!2sClearwater%2C%20FL%2C%20USA!5e0!3m2!1sen!2sus!4v1700000000000!5m2!1sen!2sus',
    },
  },
};

export default config;
